export default "__VITE_PUBLIC_ASSET__7047a336__"